import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import "./BlogDetail.css";
import Footer from "./footer";

function BlogDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const API_BASE = "https://api.niveshly.com";

  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");

  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const generateSlug = (title) =>
    title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

  useEffect(() => {
    if (!id) {
      setError("Invalid blog URL");
      setLoading(false);
      return;
    }

    const fetchBlog = async () => {
      try {
        const res = await fetch(`${API_BASE}/blogs/${id}`);
        if (!res.ok) throw new Error("Failed to fetch blog");
        const data = await res.json();
        setBlog(data);

        const correctSlug = generateSlug(data.title);
        if (correctSlug !== slug) {
          navigate(`/blog/${correctSlug}?id=${id}`, { replace: true });
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [id, slug, navigate]);

  if (loading) return <p className="loading-text">Loading…</p>;
  if (error) return <p className="error-text">{error}</p>;
  if (!blog) return null;

  return (
    <div className="blog-detail-page">

      {/* HERO */}
      <section className="blog-detail-hero">
        <button className="back-btn" onClick={() => navigate("/blogs")}>
          ← Back
        </button>

        <h1 className="blog-title">{blog.title}</h1>

        <div className="blog-meta">
          <span>👤 {blog.author}</span>
          <span>
            📅{" "}
            {blog.created_at
              ? new Date(blog.created_at).toLocaleDateString()
              : "-"}
          </span>
          <span>👁 {blog.views || 0}</span>
        </div>
      </section>

      {/* ARTICLE CONTENT */}
      <article className="blog-article-wrapper">

        {blog.image && (
          <div className="blog-detail-image">
            <img src={blog.image} alt={blog.title} />
          </div>
        )}

        {blog.tags?.length > 0 && (
          <div className="blog-tags">
            {blog.tags.map((tag, index) => (
              <span key={index} className="blog-tag">
                {tag}
              </span>
            ))}
          </div>
        )}

        <div className="blog-body">
          <p className="blog-excerpt-text">{blog.excerpt}</p>

          <div
            className="blog-html-content"
            dangerouslySetInnerHTML={{ __html: blog.content }}
          />
        </div>

      </article>

      <Footer />
    </div>
  );
}

export default BlogDetail;
